module.exports = __webpack_public_path__ + "img/logo1.896f77ec.png";